import React from "react";
import {
    INTRO_SUBHEADING,
    INTRO_CREDITS_DESCRIPTION,
    INTRO_TOKENS_DESCRIPTION
} from './intro.consts';
import './intro.css';
import intro1 from '../../assets/images/landing/intro-card-2.png'
import intro2 from '../../assets/images/landing/intro-card-1.png'

function RemIntro() {
    return (
        <div className="intro-main" style={{ paddingTop: "30px" }}>
            <div className="left-common-div-intro left-common-div heading-respp-intro">
                <div data-aos="fade-right" data-aos-duration="900">
                    <h2 className='f-w-700 text-shadow intro-main-heading driver-heading' style={{ color: "white" }}>INTRODUCTION TO REM TOKENS <br />
                        ECOSYSTEM</h2>
                    <div className="intro-divider"></div>
                    <div className="subheading-div">
                        <p className='f-w-500 text-shadow intro-subheading' style={{ color: "white" }}>{INTRO_SUBHEADING}</p>
                    </div>
                </div>
            </div>

            <div className="intro-cards-upper-div">
                <div className="scale-div">
                    <div className="intro-card-parent-2 lower-card" data-aos-duration="500" data-aos="fade-left">
                        <img src={intro1} alt="card-1" className="intro-img1" />
                        <div className="intro-card intro-card-1-margin">
                            {window.innerWidth > 1125 ? (<div style={{ border: "1px solid #92D050", height: "86%", width: ".7%", backgroundColor: "#92D050", margin: "10px 30px 10px 60px" }}></div>) : null}
                            <div className="int-card-1">
                                <h3 className="card-heading">REM CREDITS:</h3>
                                <p className="card-text text-shadow" style={{ color: "white" }}>
                                    {INTRO_CREDITS_DESCRIPTION}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="intro-card-parent-2" data-aos-duration="500" data-aos="fade-left">
                        <img src={intro2} alt="card-2" className="intro-img2" />
                        <div className="intro-card intro-card-2-margin">
                            {window.innerWidth > 1125 ? (<div style={{ border: "1px solid #92D050", height: "86%", width: ".7%", backgroundColor: "#92D050", margin: "10px 30px 10px 60px" }}></div>) : null}
                            <div className="int-card-1">
                                <h3 className="card-heading">REM TOKENS:</h3>
                                <p className="card-text text-shadow" style={{ color: "white" }}>
                                    {INTRO_TOKENS_DESCRIPTION}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RemIntro;
